module.exports = __webpack_public_path__ + "img/pingguo.f8080b48.png";